import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import logoutImg from "assets/img/icons/spot-illustrations/45.png";
import { logout } from "features/auth/authSlice";

import paths from "routes/paths";

const loginPaths = {
  simple: paths.simpleLogin,
  split: paths.splitLogin,
  card: paths.cardLogin,
};

const LogoutContent = ({ layout, titleTag: TitleTag }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Clears the stored tokens, the JWT mirror cookie and the API caches.
    dispatch(logout());
  }, []);
  return (
    <>
      <img
        className="d-block mx-auto mb-4"
        src={logoutImg}
        alt="shield"
        width={100}
      />
      <TitleTag>See you again!</TitleTag>
      <p>
        Thanks for using the MSME Revolving Fund portal.
        <br className="d-none d-sm-block" /> You are now successfully signed
        out.
      </p>
      <Button
        as={Link}
        color="primary"
        size="sm"
        className="mt-3"
        to={loginPaths[layout]}
      >
        <FontAwesomeIcon
          icon="chevron-left"
          transform="shrink-4 down-1"
          className="me-1"
        />
        Return to Login
      </Button>
    </>
  );
};

LogoutContent.propTypes = {
  layout: PropTypes.string,
  titleTag: PropTypes.string,
};

LogoutContent.defaultProps = {
  layout: "simple",
  titleTag: "h4",
};

export default LogoutContent;
